import React from 'react';

const VARIANT_CLASS = {
    warning: 'page-banner page-banner--warning bg_red',
    success: 'page-banner page-banner--success bg_green',
};

export default function PageBanner({ variant = 'warning', message, actions }) {
    const className = VARIANT_CLASS[variant] || VARIANT_CLASS.warning;
    return (
        <div className={className}>
            <span>{message}</span>
            {actions ? <div className="page-banner__actions">{actions}</div> : null}
        </div>
    );
}
